<template>
  <v-dialog v-model="dialog" persistent width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        tile
        outlined
        depressed
        color="primary"
        dark
        v-on="on"
        @click="dialog = true"
        class="ml-1"
        ><v-icon small color="primary">mdi-file-export-outline</v-icon>Export to
        Csv</v-btn
      >
    </template>

    <v-card>
      <validation-observer v-slot="{ invalid }" ref="form">
        <v-card-title>Export Payment Batches</v-card-title>
        <v-card-text>
          <date-picker
            :value="startDate"
            :field="{ label: 'From' }"
            @fieldChange="startDate = $event"
            :validations="{ required: true }"
          ></date-picker>
          <v-spacer class="my-4"></v-spacer>
          <date-picker
            :value="endDate"
            :field="{ label: 'To' }"
            @fieldChange="endDate = $event"
            :validations="{ required: true }"
          ></date-picker>
          <v-spacer class="my-4"></v-spacer>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="loading" @click="clear">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            @click="exportPaymentBatches"
            >Download
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
import { formatDateForFilename } from "../../utils/format-utils";
export default {
  data() {
    return {
      dialog: false,
      startDate: "",
      endDate: "",
      loading: false,
    };
  },
  computed: {
    fileName() {
      return `Payment Batches ${formatDateForFilename(
        this.startDate
      )} to ${formatDateForFilename(this.endDate)}.csv`;
    },
  },
  methods: {
    async exportPaymentBatches() {
      this.loading = true;
      var response = await this.$store.dispatch(
        "paymentBatchModule/exportPaymentBatches",
        {
          start: this.startDate,
          end: this.endDate,
        }
      );
      if (response) {
        await downloadFile(response, this.fileName);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.loading = false;
      this.clear();
    },
    clear() {
      this.$refs.form.reset();
      this.dialog = false;
      this.startDate = "";
      this.endDate = "";
    },
  },
};
</script>
